export default __webpack_public_path__ + "assets/24789ce4c26511ca16678a877fccfd7b.webp";